"use client";

import { ReactNode } from "react";
import ReduxProvider from "./ReduxProvider";

export default function AppProviders({
  children,
}:  Readonly<{
  children: ReactNode;
}>) {
  return <ReduxProvider>{children}</ReduxProvider>;
}
